import { render, staticRenderFns } from "./AppInstaller.vue?vue&type=template&id=29010a1c"
import script from "./AppInstaller.vue?vue&type=script&lang=js"
export * from "./AppInstaller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports